import React from 'react';
import DatePickerHeader from '../DatePickerHeader';
import { StyledDateRange } from './DatePicker.styles';

function ReactDateRange({
  prefix,
  disabled,
  excludeDateIntervals,
  invalid,
  error,
  onChange,
  value,
  selectsRange = false, // ✅ control single or range mode
  ...props
}) {
  return (
    <StyledDateRange
      colorBg
      inputSm
      disabled={disabled}
      excludeDateIntervals={excludeDateIntervals}
      prefix={prefix}
      invalid={invalid || error}
      selectsRange={selectsRange}
      startDate={selectsRange && value?.[0] ? new Date(value[0]) : null}
      endDate={selectsRange && value?.[1] ? new Date(value[1]) : null}
      selected={!selectsRange && value ? new Date(value) : null}
      dateFormat="MMM dd, yyyy"
      popperPlacement="bottom-start"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <DatePickerHeader
          date={date}
          changeYear={changeYear}
          changeMonth={changeMonth}
          decreaseMonth={decreaseMonth}
          increaseMonth={increaseMonth}
          prevMonthButtonDisabled={prevMonthButtonDisabled}
          nextMonthButtonDisabled={nextMonthButtonDisabled}
        />
      )}
      {...props}
      onChange={dates => {
        if (selectsRange) {
          const [start, end] = dates || [];
          onChange({
            target: {
              value: [start ? start.toISOString() : null, end ? end.toISOString() : null],
              name: props.name,
            },
          });
        } else {
          const date = dates;
          onChange({
            target: {
              value: date ? date.toISOString() : null,
              name: props.name,
            },
          });
        }
      }}
    />
  );
}

// function ReactDateRange({
//   prefix,
//   suffix,
//   disabled,
//   excludeDateIntervals,
//   invalid,
//   error,
//   onChange,
//   timeOnly,
//   excludeTimes,
//   startTime,
//   endTime,
//   colorBg,
//   ...props
// }) {
//   return (
//     <>
//       {timeOnly ? (
//         <>
//           <StyledDateRange
//             disabled={disabled}
//             prefix={prefix}
//             suffix={suffix}
//             invalid={invalid || error}
//             showTimeSelectOnly
//             showTimeSelect
//             selected={startTime}
//             startDate={startTime}
//             onChange={_ => {
//               onChange({ target: { value: _, name: 'startTime' } });
//             }}
//             timeIntervals={30}
//             timeCaption="Time"
//             dateFormat="HH:mm"
//             placeholderText="Select Start Time"
//             {...props}
//           />
//           <StyledDateRange
//             disabled={disabled}
//             prefix={prefix}
//             suffix={suffix}
//             invalid={invalid || error}
//             showTimeSelectOnly
//             showTimeSelect
//             selected={endTime}
//             endDate={endTime}
//             onChange={_ => {
//               onChange({ target: { value: _, name: 'endTime' } });
//             }}
//             timeIntervals={30}
//             timeCaption="Time"
//             dateFormat="HH:mm"
//             placeholderText="Select End Time"
//             {...props}
//           />
//         </>
//       ) : (
//         <StyledDateRange
//           disabled={disabled}
//           excludeDateIntervals={excludeDateIntervals}
//           prefix={prefix}
//           suffix={suffix}
//           invalid={invalid || error}
//           renderCustomHeader={({
//             date,
//             changeYear,
//             changeMonth,
//             decreaseMonth,
//             increaseMonth,
//             prevMonthButtonDisabled,
//             nextMonthButtonDisabled,
//           }) => (
//             <DatePickerHeader
//               date={date}
//               changeYear={changeYear}
//               changeMonth={changeMonth}
//               decreaseMonth={decreaseMonth}
//               increaseMonth={increaseMonth}
//               prevMonthButtonDisabled={prevMonthButtonDisabled}
//               nextMonthButtonDisabled={nextMonthButtonDisabled}
//             />
//           )}
//           {...props}
//           onChange={_ => {
//             onChange({ target: { value: _, name: props.name } });
//           }}
//         />
//       )}
//     </>
//   );
// }

export default ReactDateRange;
